import Route from "../../../router/Route";
import { RouterView } from "vue-router";

import ScreensOverview from "../pages/ScreensOverview.vue";
import OpportunitiesOverview from "../pages/OpportunitiesOverview.vue";

import ScreenListing from "../components/screens/ListingOverview.vue";
import ScreenSizing from "../components/screens/SizingOverview.vue";
import ScreenGrouping from "../components/screens/GroupingOverviw.vue";

import OpportunitiesListing from "../components/opportunities/ListingOverview.vue";
import OpportunityDetail from "../components/opportunities/DetailView.vue";

import FlightDetail from "../components/opportunities/flight/DetailView.vue";
import DetailViewProcessSegments from "../components/opportunities/flight/DetailViewProcessSegments.vue";
import DetailViewRefineSegments from "../components/opportunities/flight/DetailViewRefineSegments.vue";

export default new Route(
	"campaignplanner",
	"/campaign-planner",
	RouterView,
	[
		new Route(
			"opportunities.index",
			"opportunities",
			OpportunitiesOverview,
			[
				new Route(
					"opportunities.listing",
					"listing",
					OpportunitiesListing,
					[],
					{
						permissions: ["can_manage_opportunities"],
					}
				),
				new Route(
					"opportunity.detail",
					"detail/:opportunity_uuid",
					OpportunityDetail,
					[],
					{
						permissions: ["can_manage_opportunities"],
					}
				),
				new Route(
					"flight.detail",
					"flight-detail/:flight_uuid",
					FlightDetail,
					[],
					{
						permissions: ["can_manage_opportunities"],
					}
				),
				new Route(
					"flight.detail.process.segments",
					"flight-detail/:flight_uuid/process-segments",
					DetailViewProcessSegments,
					[],
					{
						permissions: ["can_manage_opportunities"],
					}
				),
				new Route(
					"flight.detail.refine.segments",
					"flight-detail/:flight_uuid/refine-segments",
					DetailViewRefineSegments,
					[],
					{
						permissions: ["can_manage_opportunities"],
					}
				),
			],
			{
				permissions: ["can_manage_opportunities"],
			},
			"/campaign-planner/opportunities/listing"
		),
		new Route(
			"screens.index",
			"screens",
			ScreensOverview,
			[
				new Route("screens.listing", "listing", ScreenListing, [], {
					permissions: ["can_manage_screens"],
				}),
				new Route("screens.sizing", "sizing", ScreenSizing, [], {
					permissions: ["can_manage_screens"],
				}),
				new Route("screens.grouping", "grouping", ScreenGrouping, [], {
					permissions: ["can_manage_screens"],
				}),
			],
			{
				permissions: ["can_manage_screens"],
			},
			"/campaign-planner/screens/listing"
		),
	],
	{},
	"/campaign-planner/opportunities"
);
